if (!customElements.get('product-v2-faq')) {
  customElements.define(
    'product-v2-faq',
    class ProductV2Faq extends HTMLElement {
      connectedCallback() {
        const toggle = this.querySelector('[data-faq-toggle]');
        if (!toggle) return;

        const moreLabel = toggle.querySelector('[data-faq-more]');
        const lessLabel = toggle.querySelector('[data-faq-less]');

        toggle.addEventListener('click', () => {
          const expanded = this.classList.toggle('is-expanded');

          if (moreLabel) moreLabel.hidden = expanded;
          if (lessLabel) lessLabel.hidden = !expanded;
          toggle.setAttribute('aria-expanded', String(expanded));
        });
      }
    }
  );
}
